/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Delete_Default_NoteInputs */



/**
* | output |
* | --- |
* | "A default cannot be deleted." |
*
* @param {Settings_Template_Delete_Default_NoteInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_delete_default_note = /** @type {((inputs?: Settings_Template_Delete_Default_NoteInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Delete_Default_NoteInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Een standaard kan je niet verwijderen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un modèle par défaut ne peut pas être supprimé.")
	return /** @type {LocalizedString} */ ("A default cannot be deleted.")
});